const encoder = new TextEncoder();

export const PASSWORD_ITERATIONS = 600_000;
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 128;

function base64Url(bytes: Uint8Array): string {
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/u, "");
}

export function isPasswordCredential(value: unknown): value is string {
  return typeof value === "string" && /^v1\$[A-Za-z0-9_-]{43}$/u.test(value);
}

export async function derivePasswordCredential(email: string, password: string): Promise<string> {
  const length = [...password].length;
  if (length < PASSWORD_MIN_LENGTH || length > PASSWORD_MAX_LENGTH) {
    throw new Error(`密码长度必须为 ${PASSWORD_MIN_LENGTH}–${PASSWORD_MAX_LENGTH} 个字符。`);
  }

  const salt = await crypto.subtle.digest(
    "SHA-256",
    encoder.encode(`stellar-colony-password-v1\0${email.trim().toLowerCase()}`),
  );
  const key = await crypto.subtle.importKey("raw", encoder.encode(password), "PBKDF2", false, ["deriveBits"]);
  const bits = await crypto.subtle.deriveBits(
    { name: "PBKDF2", hash: "SHA-256", salt, iterations: PASSWORD_ITERATIONS },
    key,
    256,
  );
  return `v1$${base64Url(new Uint8Array(bits))}`;
}
